import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { notification, Authentication } from "../services";

const INITIAL_STATE = {
  email: "",
  password: "",
  error: "",
  submitting: false
};

class SignIn extends Component {
  state = INITIAL_STATE;

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = async e => {
    e.preventDefault();
    const { email, password } = this.state;
    this.setState({ submitting: true });
    if (await Authentication.login(email, password)) {
      notification.success("Welcome!");
      this.setState({ submitting: false });
      setTimeout(() => {
        window.location.href = "/";
      }, 1000);
    } else {
      this.setState({ submitting: false });
      notification.error("Please provide valid credentials");
    }
  };

  isInvalid = () =>
    this.state.submitting ||
    this.state.email === "" ||
    this.state.password === "";

  render() {
    const { email, password, error } = this.state;
    const invalid = this.isInvalid();

    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-5 col-xl-4 my-5">
            <div className="text-center">
              <Link to={"/"}>
                <img
                  src="/assets/img/logo.png"
                  width="230"
                  alt="Photon Commerce logo"
                />
              </Link>
            </div>

            <p className="text-muted text-center mt-3 mb-5">
              Log in with your credentials
            </p>

            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <label>Work email</label>

                <input
                  type="email"
                  id="si-email"
                  className="form-control"
                  name="email"
                  placeholder="Ex: you@company.com"
                  autoFocus="autofocus"
                  tabIndex={1}
                  value={email}
                  onChange={this.onChange}
                />
              </div>

              <div className="form-group">
                <div className="row">
                  <div className="col">
                    <label>Password</label>
                  </div>
                  <div className="col-auto">
                    <Link
                      to={"/forgot-password"}
                      className="form-text small text-muted"
                    ></Link>
                  </div>
                </div>

                <div className="input-group input-group-merge">
                  <input
                    type="password"
                    className="form-control form-control-appended"
                    name="password"
                    placeholder="Enter your password"
                    tabIndex={2}
                    value={password}
                    onChange={this.onChange}
                  />

                  <div className="input-group-append">
                    <span className="input-group-text">
                      <i className="fe fe-eye"></i>
                    </span>
                  </div>
                </div>
              </div>

              {error && <p className="text-danger">{error.message}</p>}

              <button
                type="submit"
                className="btn btn-lg btn-block btn-primary mb-3"
                disabled={invalid}
              >
                {this.state.submitting ? "Signing in..." : "Sign in"}
              </button>

              <div className="text-center">
                <small className="text-muted text-center">
                  Don't have an account yet?{" "}
                  <Link to={"/sign-up"}>Sign up</Link>.
                </small>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignIn);
